import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import BrainMenu from "@/components/BrainMenu";
import HeroErrorBoundary from "@/components/HeroErrorBoundary";
import Philosophy from "@/components/Philosophy";
import Ecosystem from "@/components/Ecosystem";
import Method from "@/components/Method";
import Academy from "@/components/Academy";
import Roadmap from "@/components/Roadmap";
import { MarketDashboard, TickerTape } from "@/components/TradingView";
import Pricing from "@/components/Pricing";
import Community from "@/components/Community";
import FutureVision from "@/components/FutureVision";
import Founder from "@/components/Founder";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import CoachWidget from "@/components/CoachWidget";

export default function Landing() {
  useEffect(() => {
    document.title = "MBM, Mind Before Markets | Trading Psychology Mentorship Melbourne";
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative bg-[#0A0A0A] text-[#FAFAFA] min-h-screen">
      <div className="grain" />
      <Navbar />
      <main>
        <HeroErrorBoundary>
          <BrainMenu />
        </HeroErrorBoundary>
        <Philosophy />
        <Ecosystem />
        <Method />
        <Academy />
        <Roadmap />
        <MarketDashboard />
        <Pricing />
        <Community />
        <FutureVision />
        <Founder />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <div style={{ height: 52 }} aria-hidden />
      <TickerTape />
      <CoachWidget />
    </div>
  );
}
